import React from 'react'
import Typed from "typed.js";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { FaTwitter, FaGithub, FaLinkedin } from "react-icons/fa";


function LandinPage() {
	const el = React.useRef(null);
	const typed = React.useRef(null);
  const navigate = useNavigate()

    const socialMediaLinks = [
      {
        id: 0,
        link: "https://linkedin.com/in/vikram-amin-52b55815a",
        icon: <FaLinkedin />,
      },
      {
        id: 1,
        link: "https://github.com/Vikram-amin",
        icon: <FaGithub />,
      },
      {
        id: 2,
        link: "https://twitter.com/vikram56201675",
        icon: <FaTwitter />,
      },
    ];

  React.useEffect(() => {    
    const options = {
    	strings: [
        'Full Stack Developer',
        'MERN Stack',
      ],
      typeSpeed: 50,
      backSpeed: 50,
      loop:true,
    };
    typed.current = new Typed(el.current, options);
    return () => {
      typed.current.destroy();
    }
  }, [])



  const navigateTo = () => {
    navigate("/projects");
  }

  return (
    <HeaderContent className="wrap">
      <Left>
        <h1>
          <HeadingSpan> Hi all! I'm </HeadingSpan> <Name> Vikram</Name>{" "}
          <Wave> 👋🏻 </Wave>
        </h1>

        <TextAnimation className="type-wrap">
          <span style={{ whiteSpace: "pre" }} ref={el} />
        </TextAnimation>

        <HeaderUl>
          {socialMediaLinks.map((item) => (
            <HeaderIconDiv key={item.id}>
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                <HeaderIcon>{item.icon}</HeaderIcon>
              </a>
            </HeaderIconDiv>
          ))}
        </HeaderUl>

        <HeaderButtons>
          <A target="_blank" rel="noreferrer" href="/resume/Resume.pdf">
            Resume
          </A>
          &nbsp;&nbsp;&nbsp;
          <Span onClick={navigateTo}>
              Projects 
          </Span>
        </HeaderButtons>
      </Left>

      <Right>
        <Img src="/ManTable.svg" alt="Man" />
      </Right>
    </HeaderContent>
  );
}
   
  
 const HeaderContent = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   width: 80%;
   color: ${(props) => props.theme.text.main};
   margin: auto;

   @media ${(props) => props.theme.breakpoints.tablet} {
     display: block;
   }
 `;

  const Left = styled.div`
    width: 50%;
    @media ${(props) => props.theme.breakpoints.tablet} {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
   }
}
  `;

  const Right = styled.div`
    width: 50%;
    @media ${(props) => props.theme.breakpoints.tablet} {
      display: none;
    }
  `;

 const HeadingSpan = styled.span`
   font-size: 45px;
   font-weight: 500;
   color: ${(props) => props.theme.text.secondary};
 `;

  const Name = styled.span`
    font-size: 55px;
    font-weight: 700;
  `;

  const TextAnimation = styled.div`
    font-size: 35px;
    font-weight: 500;
  
    color: ${(props) => props.theme.text.main};
  `;

 const A = styled.a`
   outline: none;
   border: none;
   color: #fff;
   text-decoration: none;
   border: 1px solid rgb(211, 220, 230);
   background-color: ${(props) => props.theme.LightTheme.fontColorPrimary};
   color: ${(props) => props.theme.text.main};
   border-radius: 5px 5px 5px 5px;
   padding: 13px 40px;
   &:hover {
     color: #fff;
     border: 1px solid rgb(211, 220, 230);
   }
 `;

 const HeaderButtons = styled.div`
   object-fit: cover;
   justify-content: space-between;
   margin-top: 50px;
 `;

 const Span = styled.button`
   font-size: 15px;
   outline: none;
   border: none;
   color: #fff;
   text-decoration: none;
   list-style: none;
   border: 1px solid rgb(211, 220, 230);
   background-color: ${(props) => props.theme.LightTheme.fontColorPrimary};
   color: ${(props) => props.theme.text.main};
   border-radius: 5px 5px 5px 5px;
   padding: 15px 45px;
   &:hover {
     color: #fff;
     border: 1px solid rgb(211, 220, 230);
   }
 `;

 const HeaderUl = styled.div`
  width:50%;
   list-style-type: none;
   display: flex;
   margin-bottom: 20px;
   color: #fff;
   justify-content: center;
   @media (max-width: 650px) {
     justify-content: center;
   }
 `;

 const HeaderIconDiv = styled.div`
  margin-top:30px ;
  margin-bottom:20px;
 `;

 const HeaderIcon = styled.div`
   width: 50px;
   height: 50px;
   border 1px solid white;
   background-color: ${(props) => props.theme.LightTheme.fontColorPrimary};
   color: ${(props) => props.theme.text.main};
   border-radius: 50%;
   display: flex;
   align-items: center;
   justify-content: center;
   margin: 0 10px;
   transition: all 0.5s linear;
   cursor: pointer;
   &:first-child {
     margin-left: 0;
   }
 `;
 

 const Img= styled.img`
   width:100%;
   margin-top:50px;
   margin-bottom:50px;

 `

 const Wave = styled.span`
   font-size: 57px;
   animation-duration: 1.8s;
   animation-iteration-count: infinite;
   animation-name: wave;
   display: inline-block;
   transform-origin: 70% 70%;

   @keyframes wave {
     0% {
       transform: rotate(0deg);
     }
     10% {
       transform: rotate(-10deg);
     }
     20% {
       transform: rotate(12deg);
     }
     30% {
       transform: rotate(-10deg);
     }
     40% {
       transform: rotate(9deg);
     }
     50% {
       transform: rotate(0deg);
     }
     100% {
       transform: rotate(0deg);
     }
   }
 `;


export default LandinPage



